import React from 'react';
import { Link } from 'react-router-dom';
import PublicLayout from '../../components/layout/PublicLayout';

const PaymentCancelPage: React.FC = () => {
  return (
    <PublicLayout>
      <div className="py-24 sm:py-32">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          {/* Cancel Icon */}
          <div className="w-20 h-20 bg-yellow-100 dark:bg-yellow-900/30 rounded-full flex items-center justify-center mx-auto mb-8">
            <svg
              className="w-10 h-10 text-yellow-600 dark:text-yellow-400"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
              />
            </svg>
          </div>

          {/* Message */}
          <h1 className="text-3xl sm:text-4xl font-extrabold text-gray-900 dark:text-white mb-4">
            Payment Cancelled
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-300 mb-8">
            Your payment was cancelled and you have not been charged. If you experienced
            any issues, please don't hesitate to contact us.
          </p>

          {/* Info Box */}
          <div className="bg-blue-50 dark:bg-slate-800 rounded-2xl p-8 mb-8">
            <h2 className="text-lg font-semibold text-gray-900 dark:text-white mb-4">
              Why Go Premium?
            </h2>
            <ul className="text-left text-gray-600 dark:text-gray-300 space-y-3">
              <li className="flex items-start">
                <svg
                  className="flex-shrink-0 w-5 h-5 text-blue-500 mt-0.5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <span className="ml-3">
                  <strong>Unlimited recordings</strong> - Practice as much as you want
                </span>
              </li>
              <li className="flex items-start">
                <svg
                  className="flex-shrink-0 w-5 h-5 text-blue-500 mt-0.5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <span className="ml-3">
                  <strong>Phoneme analysis</strong> - See exactly which sounds need work
                </span>
              </li>
              <li className="flex items-start">
                <svg
                  className="flex-shrink-0 w-5 h-5 text-blue-500 mt-0.5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <span className="ml-3">
                  <strong>AI coaching tips</strong> - Get personalized improvement suggestions
                </span>
              </li>
              <li className="flex items-start">
                <svg
                  className="flex-shrink-0 w-5 h-5 text-blue-500 mt-0.5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <span className="ml-3">
                  <strong>Progress tracking</strong> - Monitor your improvement over time
                </span>
              </li>
            </ul>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row justify-center gap-4">
            <Link
              to="/pricing"
              className="inline-flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-lg text-white bg-blue-600 hover:bg-blue-700 transition-colors"
            >
              View Plans Again
            </Link>
            <Link
              to="/app"
              className="inline-flex items-center justify-center px-8 py-3 border border-gray-300 dark:border-slate-600 text-base font-medium rounded-lg text-gray-700 dark:text-gray-200 bg-white dark:bg-slate-800 hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors"
            >
              Continue with Free
            </Link>
          </div>

          {/* Help Link */}
          <p className="mt-8 text-gray-500 dark:text-gray-400">
            Having issues?{' '}
            <Link to="/contact" className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300">
              Contact our support team
            </Link>
          </p>
        </div>
      </div>
    </PublicLayout>
  );
};

export default PaymentCancelPage;
